// Rename this file to "firebaseConfig.js" before use
// Replace all XXXXs with real Firebase API keys

export default {
  
  // apiKey: 'AIzaSyB0_6oAK8t9_8E5_D0XgtGLQ_C40xanvHE',
  // authDomain: 'stocks-ca02d.firebaseapp.com',
  // databaseURL: 'https://stocks-ca02d.firebaseio.com',
  // projectId: 'stocks-ca02d',
  // storageBucket: 'stocks-ca02d.appspot.com',
  // messagingSenderId: '1086221498665',
  // appId: '1:1086221498665:web:9a27448ebc0cf975849f38'
  apiKey: "AIzaSyARI0TzY7Qj_Z_XqwxXYxsZn1zGGCaWJVI",
  authDomain: "stonk1.firebaseapp.com",
  databaseURL: "https://stonk1.firebaseio.com",
  projectId: "stonk1",
  storageBucket: "stonk1.appspot.com",
  messagingSenderId: "927258777238",
  appId: "1:927258777238:web:b3f51d6bfcab9399e394b7",
  measurementId: "G-K04JD3ZZQM"
};
